import { Component, OnInit } from '@angular/core';

import { Router } from '@angular/router';
import { FormBuilder, FormGroup, Validators, FormsModule } from '@angular/forms';
import { first } from 'rxjs/operators';

//import { UserService } from '../../services/user.service';
import { CommonDataService } from '../../services/common-data.service';
import { CommerceDataService } from '../../services/commerce-data.service';
import { environment } from '../../../environments/environment';

declare var $:any;
declare var iziToast:any;

@Component({
  selector: 'app-account-orders-page',
  templateUrl: './account-orders-page.component.html',
  styleUrls: ['./account-orders-page.component.css']
})
export class AccountOrdersPageComponent implements OnInit {

  pageName = "My Orders";

  orders = []
  pageReady = false;
  numberOfOrders = 0

  p: number = 1;
  itemsPerPage = 15;
  items = 0

  constructor(
    private formBuilder: FormBuilder,
    private router: Router,
    private _data: CommonDataService,
    private _ecomm: CommerceDataService
  ) { }

  ngOnInit() {

    $('#initialise-page').trigger('click');
    this.getOrders()
  }

  getOrders() {
    let queryData = new FormData();

    let userId = sessionStorage.getItem('context')
    queryData.append('modelName', 'BackOrder');

    if(!userId) {
        $('#loader').hide();
        // redirect to login 
        return false;
    }

    queryData.append('context_id', userId);

      $('#loader').show();
      //lets get the model for this page
      this._data.getModelData(queryData) 
      .pipe(first())
      .subscribe(
        data => {
          this.orders = data['covers'];
          this.numberOfOrders = this.orders.length
          this.pageReady = true;
          this.items = this.orders.length
        },
        error => {

            $('#loader').hide();

        },

        () => {
          $('#loader').hide();
        }
      );
  }

}
